import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { arrowLeftIcon, arrowRightIcon } from '../icons/icons';
import { sharedStyles } from '../shared-styles';

@customElement('list-navigation')
export class ListNavigation extends LitElement {
  static styles = [
    sharedStyles,
    css`
      :host {
        color: var(--primary-color);
        font-weight: bold;
      }

      .row {
        display: inline-flex;
        flex-direction: row;
      }

      .index-counter {
        margin-left: 20px;
        margin-right: 20px;
      }

      .empty {
        width: 30px;
      }
    `,
  ];

  @property({ type: Number, reflect: true })
  public total = 0;

  @property({ type: Number, reflect: true })
  public limit = 20;

  @property({ type: Number, reflect: true })
  public index = 0;

  constructor() {
    super();
  }

  render() {
    if (this.total < this.limit) {
      return html``;
    }

    return html`
      <div class="row">
        ${this.renderLeftArrow()}
        <div class="index-counter">${this.index + 1}</div>
        ${this.renderRightArrow()}
      </div>
    `;
  }

  renderLeftArrow() {
    if (this.index <= 0) {
      return html`<div class="empty"></div>`;
    }
    return html`<div
      @click="${() => {
        if (this.index > 0) {
          this.index--;
          this.navigationChanged();
        }
      }}"
    >
      ${arrowLeftIcon()}
    </div>`;
  }

  renderRightArrow() {
    const maxIndex = Math.ceil(this.total / this.limit);

    if (this.index >= maxIndex - 1) {
      return html`<div class="empty"></div>`;
    }
    return html`<div
      @click="${() => {
        if (this.index < maxIndex - 1) {
          this.index++;
          this.navigationChanged();
        }
      }}"
    >
      ${arrowRightIcon()}
    </div>`;
  }

  navigationChanged = () => {
    const event = new CustomEvent('change', {
      detail: {
        value: JSON.stringify(this.index),
      },
    });
    this.dispatchEvent(event);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'list-navigation': ListNavigation;
  }
}
